export default __webpack_public_path__ + "static/instantChatBg1-e16feadd7696dccde53d56f74dc3551c.png";